import { useFormConnect } from '../../../../hooks/useFormConnect';
import { InputBox } from '../../Inputs/InputBox';

export const Text = ({
  name,
  label = '',
  placeholder = '',
  disabled = false,
}) => {
  const props = useFormConnect(name);
  return (
    <InputBox
      type="string"
      disabled={disabled}
      placeholder={placeholder}
      label={label}
      {...props}
    ></InputBox>
  );
};
